import LoginContainer from "./LoginContainer";
import LoginStore from "./LoginStore";

export default LoginStore(LoginContainer);
